import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { NavLink } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";

const statutDataHelp = {
  payer: true,
  Vendu: true,
  Louer: true,
  "Effecuter un paiement": true,
  Modifier: true,
  desactive: true,
  Désactivé: true,
  "Renouveler le contrat": true,
  "Rendre undefined": true,
};

const BtnMenu = ({
  menuIcone,
  menuName,
  handleAction,
  menuIdData,
  handleClose,
  isTooltip,
  statut,
}) => {
  const lien = "#";
  return (
    <>
      {isTooltip && (
        <Tooltip title="impayer">
          <MenuItem>
            {menuIcone} {menuName}
          </MenuItem>
        </Tooltip>
      )}
      {!isTooltip && (
        <a
          href={lien}
          className="text-secondary"
          onClick={(e) => {
            e.preventDefault();
            console.log("menuIdData", menuIdData);
            handleClose();
            handleAction(menuIdData);
          }}
          style={{
            textDecoration: "none",
            display:
              statutDataHelp[statut] && statutDataHelp[menuName]
                ? "none"
                : "block",
          }}>
          <MenuItem>
            {menuIcone} {menuName}
          </MenuItem>
        </a>
      )}
    </>
  );
};
function MenuPoint({ optionMenu, idData, statut }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        transformOrigin={{
          horizontal: "right",
          vertical: "bottom",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}>
        {optionMenu.map((menu, index) =>
          !menu.addMethodClick ? (
            <CompomentNavLink
              key={index}
              menuName={menu.name}
              menuPath={menu.path}
              menuIsIdData={menu.isIdData}
              menuIcone={menu.icone}
              handleClose={handleClose}
              idData={idData}
              statut={statut}
            />
          ) : (
            <BtnMenu
              statut={statut}
              menuIcone={menu.icone}
              menuName={menu.name}
              menuIdData={idData}
              key={index}
              handleAction={menu.methode}
              handleClose={handleClose}
              isTooltip={menu.isTooltip}
            />
          )
        )}
      </Menu>
    </>
  );
}

const CompomentNavLink = ({
  statut,
  menuName,
  menuPath,
  menuIsIdData,
  menuIcone,
  idData,
  handleClose,
}) => {
  return (
    <NavLink
      style={{
        textDecoration: "none",
        color: "gray",
        display:
          statutDataHelp[statut] && statutDataHelp[menuName] ? "none" : "block",
      }}
      to={menuIsIdData ? `${menuPath}` + idData : `${menuPath}`}
      onClick={handleClose}>
      <MenuItem>
        {menuIcone} {menuName}
      </MenuItem>
    </NavLink>
  );
};

export default MenuPoint;
